/* Pielnora v2 FX - scroll reveal, before/after sliders, hero parallax, ticker.
   Progressive enhancement: without JS (or with reduced motion) the page renders
   fully static and complete. */
(function(){
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reduced motion: stop autoplay video ---- */
  if (reduceMotion) {
    document.querySelectorAll('video[autoplay]').forEach(function(v){
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  /* ---- header shadow on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScrollHeader = function(){ header.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScrollHeader, {passive:true});
    onScrollHeader();
  }

  /* ---- ticker: duplicate track content for a seamless loop ---- */
  document.querySelectorAll('.ticker__track').forEach(function(track){
    track.innerHTML += track.innerHTML;
  });

  /* ---- before/after drag sliders (from static .ba-card__images pairs) ---- */
  document.querySelectorAll('.ba-card__images').forEach(function(w){
    var imgs = w.querySelectorAll('img');
    if (imgs.length !== 2) return;
    w.classList.add('ba-slider');

    var afterWrap = document.createElement('div');
    afterWrap.className = 'ba-after';
    afterWrap.appendChild(imgs[1]);
    w.appendChild(afterWrap);

    var handle = document.createElement('div');
    handle.className = 'ba-handle';
    w.appendChild(handle);

    var chipB = document.createElement('span');
    chipB.className = 'ba-chip ba-chip--before'; chipB.textContent = 'Before';
    var chipA = document.createElement('span');
    chipA.className = 'ba-chip ba-chip--after'; chipA.textContent = 'After';
    w.appendChild(chipB); w.appendChild(chipA);

    var range = document.createElement('input');
    range.type = 'range'; range.min = '0'; range.max = '100'; range.value = '50';
    range.className = 'ba-range';
    range.setAttribute('aria-label', 'Reveal the after photo');
    w.appendChild(range);

    function set(p){
      p = Math.max(0, Math.min(100, p));
      afterWrap.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      handle.style.left = p + '%';
      chipB.style.opacity = p < 12 ? '0' : '1';
      chipA.style.opacity = p > 88 ? '0' : '1';
    }
    range.addEventListener('input', function(){ set(+range.value); });

    // direct pointer drag anywhere on the card (range only catches its thumb track)
    var dragging = false;
    function fromEvent(e){
      var r = w.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var p = x / r.width * 100;
      range.value = p;
      set(p);
    }
    w.addEventListener('pointerdown', function(e){
      if (e.target === range) return;
      dragging = true; w.setPointerCapture(e.pointerId); fromEvent(e);
    });
    w.addEventListener('pointermove', function(e){ if (dragging) fromEvent(e); });
    w.addEventListener('pointerup', function(){ dragging = false; });
    w.addEventListener('pointercancel', function(){ dragging = false; });

    set(50);
  });

  /* ---- scroll reveal ---- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var SELECTORS = [
      '.sechead', '.anchor-band', '.talk > p', '.edu > div', '.pcard',
      '.media-duo figure', '.tl > div', '.spot', '.ba-card', '.ugc',
      '.plan', '.gband', '.faq details', '.step', '.ing', '.pdp__gallery', '.pdp__info'
    ];
    var els = document.querySelectorAll(SELECTORS.join(','));
    var byParent = new Map();
    els.forEach(function(el){
      el.classList.add('rv');
      // stagger siblings that reveal together (cards in a grid)
      var parent = el.parentElement;
      var n = byParent.get(parent) || 0;
      el.style.setProperty('--rvd', (Math.min(n, 5) * 90) + 'ms');
      byParent.set(parent, n + 1);
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) {
          en.target.classList.add('rv-in');
          io.unobserve(en.target);
        }
      });
    }, {threshold: 0.12, rootMargin: '0px 0px -6% 0px'});
    els.forEach(function(el){ io.observe(el); });
  }

  /* ---- hero parallax ---- */
  var heroBg = document.querySelector('.hero-cine__bg img, .hero-cine__bg video');
  if (heroBg && !reduceMotion) {
    var ticking = false;
    window.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var y = window.scrollY;
        if (y < window.innerHeight) heroBg.style.transform = 'translateY(' + (y * 0.22) + 'px) scale(1.06)';
        ticking = false;
      });
    }, {passive:true});
  }
})();
